var reactDom = {exports: {}};

export { reactDom as __module };
